import { Component } from '@angular/core';

@Component({
  selector: 'app-medical-file',
  standalone: true,
  imports: [],
  templateUrl: './medical-file.component.html',
  styleUrl: './medical-file.component.css'
})
export class MedicalFileComponent {

}
